<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <bita-form ref="filterForm">
            <div slot="body">
              <div class="row">
                <bita-input
                  type="text"
                  name="name"
                  label="جستجو"
                  validation-container-class="col-lg-3"
                  input-class="form-control"
                  v-model.lazy="filters.search"
                  @keyup.enter="loadData()"
                />
                <div class="col-lg-4">
                  <a class="margin-top btn btn-success" @click="loadData()">
                    جستجو
                  </a>
                  <a
                    class="margin-top margin-right btn btn-warning"
                    @click="resetFilters()"
                  >
                    پاک سازی
                  </a>
                </div>
              </div>
            </div>
          </bita-form>
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :schema-total="'total'"
            :schema-data="'data'"
            :grid-server-side="true"
            :server-paging="true"
            :batch="true"
            :page-size="pageSize"
            :current-page="currentPage"
            :has-row-number="true"
          />
        </div>
      </bita-ibox>
    </div>
  </div>
</template>
<script>
import { ownerApi } from "@/api/apiManagement.js";
export default {
  data() {
    return {
      pageSize: 30,
      currentPage: 1,
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "مدیریت صاحب بار",
          link: "/management/owners",
          active: true,
        },
      ],
      filters: {},
      isLoadingGrid: false,
      isLoadingModal: false,
      gridColumns: [
        { field: "name", title: "نام" },
        { field: "family", title: "نام خانوادگی" },
        { field: "phone", title: "موبایل" },
        { field: "type", title: "نوع" },
        { field: "postal_code", title: "کد پستی" },
        { field: "ssn_number", title: "کد ملی" },
        { field: "city_name", title: "کد ملی" },
        { field: "brand", title: "نام شرکت" },
        { field: "address", title: "آدرس", width: "200px" },
        { field: "representative_name", title: "نام نماینده" },
        {
          field: "representative_mobile",
          title: "موبایل نماینده",
          width: "150px",
        },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          width: "150px",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
        },
        {
          title: "عملیات",
          width: "120px",
          command: [],
        },
      ],
    };
  },
  mounted() {
    this.loadData();
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
  },
  methods: {
    resetFilters() {
      this.filters = {};
      this.$refs.filterForm.reset();
      let selects = Object.values(this.$refs);
      selects.forEach((el) => {
        if (el && el.emptyKendo) el.emptyKendo();
      });
    },
    readData(e) {
      this.$resetGrid();
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.isLoadingGrid = true;
      ownerApi
        .getOwners({
          page_size: this.pageSize,
          page: this.currentPage,
          ...this.filters,
        })
        .then((res) => {
          e.success(res.data.entity);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    delete(e) {
      let data = this.$refs.grid.getSelectedGridRow(e);
      this.$alert(
        "question",
        `آیا از حذف صاحب بار  ${data.name} اطمینان دارید ؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          ownerApi
            .deleteOwner(data.id)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    add(e) {      
      let data = this.$refs.grid.getSelectedGridRow(e);
      this.$alert(
        "question",
        `آیا از اضافه کردن صاحب بار  ${data.name} اطمینان دارید ؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          ownerApi
            .addOwners(data)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    gridCommands() {
      let commands = [];
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      commands.push({
        text: "user-plus",
        click: this.add,
        template: "<a role='button' class='k-button k-button-icontext k-grid-user-plus' data-toggle='tooltip' data-placement='bottom' title='اضافه کردن صاحب بار'><span class='fas fa-user-plus' style='color:teal'></span></a>",
      });
      return commands;
    },
  },
};
</script>
<style scoped></style>
